/**
 * Türkiye il/ilçe referans verisi — 81 il, 973 ilçe. Kaynak: turkey-neighbourhoods npm
 * paketi (muratgozel/turkey-neighbourhoods, MIT), cityList.json + districtsByCityCode.json
 * birleştirilip alfabetik sıralandı. Yalnızca MASAK kimlik tespiti "Yeni Müşteri"
 * formundaki il/ilçe seçimi için kullanılır (masak-uyum.md) — Customer.City/District
 * genelde serbest metin kalmaya devam ediyor, bu kasıtlı bir kapsam sınırlaması.
 */

export interface TurkeyProvince {
  il: string;
  ilceler: string[];
}

export const TURKEY_PROVINCES: TurkeyProvince[] = [
  {
    "il": "Adana",
    "ilceler": [
      "Aladağ",
      "Ceyhan",
      "Feke",
      "Karaisalı",
      "Karataş",
      "Kozan",
      "Pozantı",
      "Saimbeyli",
      "Sarıçam",
      "Seyhan",
      "Tufanbeyli",
      "Yumurtalık",
      "Yüreğir",
      "Çukurova",
      "İmamoğlu"
    ]
  },
  {
    "il": "Adıyaman",
    "ilceler": [
      "Besni",
      "Gerger",
      "Gölbaşı",
      "Kahta",
      "Merkez",
      "Samsat",
      "Sincik",
      "Tut",
      "Çelikhan"
    ]
  },
  {
    "il": "Afyonkarahisar",
    "ilceler": [
      "Bayat",
      "Başmakçı",
      "Bolvadin",
      "Dazkırı",
      "Dinar",
      "Emirdağ",
      "Evciler",
      "Hocalar",
      "Kızılören",
      "Merkez",
      "Sandıklı",
      "Sinanpaşa",
      "Sultandağı",
      "Çay",
      "Çobanlar",
      "İhsaniye",
      "İscehisar",
      "Şuhut"
    ]
  },
  {
    "il": "Aksaray",
    "ilceler": [
      "Ağaçören",
      "Eskil",
      "Gülağaç",
      "Güzelyurt",
      "Merkez",
      "Ortaköy",
      "Sarıyahşi",
      "Sultanhanı"
    ]
  },
  {
    "il": "Amasya",
    "ilceler": [
      "Göynücek",
      "Gümüşhacıköy",
      "Hamamözü",
      "Merkez",
      "Merzifon",
      "Suluova",
      "Taşova"
    ]
  },
  {
    "il": "Ankara",
    "ilceler": [
      "Akyurt",
      "Altındağ",
      "Ayaş",
      "Bala",
      "Beypazarı",
      "Elmadağ",
      "Etimesgut",
      "Evren",
      "Gölbaşı",
      "Güdül",
      "Haymana",
      "Kahramankazan",
      "Kalecik",
      "Keçiören",
      "Kızılcahamam",
      "Mamak",
      "Nallıhan",
      "Polatlı",
      "Pursaklar",
      "Sincan",
      "Yenimahalle",
      "Çamlıdere",
      "Çankaya",
      "Çubuk",
      "Şereflikoçhisar"
    ]
  },
  {
    "il": "Antalya",
    "ilceler": [
      "Akseki",
      "Aksu",
      "Alanya",
      "Demre",
      "Döşemealtı",
      "Elmalı",
      "Finike",
      "Gazipaşa",
      "Gündoğmuş",
      "Kaş",
      "Kemer",
      "Kepez",
      "Konyaaltı",
      "Korkuteli",
      "Kumluca",
      "Manavgat",
      "Muratpaşa",
      "Serik",
      "İbradı"
    ]
  },
  {
    "il": "Ardahan",
    "ilceler": [
      "Damal",
      "Göle",
      "Hanak",
      "Merkez",
      "Posof",
      "Çıldır"
    ]
  },
  {
    "il": "Artvin",
    "ilceler": [
      "Ardanuç",
      "Arhavi",
      "Borçka",
      "Hopa",
      "Kemalpaşa",
      "Merkez",
      "Murgul",
      "Yusufeli",
      "Şavşat"
    ]
  },
  {
    "il": "Aydın",
    "ilceler": [
      "Bozdoğan",
      "Buharkent",
      "Didim",
      "Efeler",
      "Germencik",
      "Karacasu",
      "Karpuzlu",
      "Koçarlı",
      "Kuyucak",
      "Kuşadası",
      "Köşk",
      "Nazilli",
      "Sultanhisar",
      "Söke",
      "Yenipazar",
      "Çine",
      "İncirliova"
    ]
  },
  {
    "il": "Ağrı",
    "ilceler": [
      "Diyadin",
      "Doğubayazıt",
      "Eleşkirt",
      "Hamur",
      "Merkez",
      "Patnos",
      "Taşlıçay",
      "Tutak"
    ]
  },
  {
    "il": "Balıkesir",
    "ilceler": [
      "Altıeylül",
      "Ayvalık",
      "Balya",
      "Bandırma",
      "Bigadiç",
      "Burhaniye",
      "Dursunbey",
      "Edremit",
      "Erdek",
      "Gömeç",
      "Gönen",
      "Havran",
      "Karesi",
      "Kepsut",
      "Manyas",
      "Marmara",
      "Savaştepe",
      "Susurluk",
      "Sındırgı",
      "İvrindi"
    ]
  },
  {
    "il": "Bartın",
    "ilceler": [
      "Amasra",
      "Kurucaşile",
      "Merkez",
      "Ulus"
    ]
  },
  {
    "il": "Batman",
    "ilceler": [
      "Beşiri",
      "Gercüş",
      "Hasankeyf",
      "Kozluk",
      "Merkez",
      "Sason"
    ]
  },
  {
    "il": "Bayburt",
    "ilceler": [
      "Aydıntepe",
      "Demirözü",
      "Merkez"
    ]
  },
  {
    "il": "Bilecik",
    "ilceler": [
      "Bozüyük",
      "Gölpazarı",
      "Merkez",
      "Osmaneli",
      "Pazaryeri",
      "Söğüt",
      "Yenipazar",
      "İnhisar"
    ]
  },
  {
    "il": "Bingöl",
    "ilceler": [
      "Adaklı",
      "Genç",
      "Karlıova",
      "Kiğı",
      "Merkez",
      "Solhan",
      "Yayladere",
      "Yedisu"
    ]
  },
  {
    "il": "Bitlis",
    "ilceler": [
      "Adilcevaz",
      "Ahlat",
      "Güroymak",
      "Hizan",
      "Merkez",
      "Mutki",
      "Tatvan"
    ]
  },
  {
    "il": "Bolu",
    "ilceler": [
      "Dörtdivan",
      "Gerede",
      "Göynük",
      "Kıbrıscık",
      "Mengen",
      "Merkez",
      "Mudurnu",
      "Seben",
      "Yeniçağa"
    ]
  },
  {
    "il": "Burdur",
    "ilceler": [
      "Altınyayla",
      "Ağlasun",
      "Bucak",
      "Gölhisar",
      "Karamanlı",
      "Kemer",
      "Merkez",
      "Tefenni",
      "Yeşilova",
      "Çavdır",
      "Çeltikçi"
    ]
  },
  {
    "il": "Bursa",
    "ilceler": [
      "Büyükorhan",
      "Gemlik",
      "Gürsu",
      "Harmancık",
      "Karacabey",
      "Keles",
      "Kestel",
      "Mudanya",
      "Mustafakemalpaşa",
      "Nilüfer",
      "Orhaneli",
      "Orhangazi",
      "Osmangazi",
      "Yenişehir",
      "Yıldırım",
      "İnegöl",
      "İznik"
    ]
  },
  {
    "il": "Denizli",
    "ilceler": [
      "Acıpayam",
      "Babadağ",
      "Baklan",
      "Bekilli",
      "Beyağaç",
      "Bozkurt",
      "Buldan",
      "Güney",
      "Honaz",
      "Kale",
      "Merkezefendi",
      "Pamukkale",
      "Sarayköy",
      "Serinhisar",
      "Tavas",
      "Çal",
      "Çameli",
      "Çardak",
      "Çivril"
    ]
  },
  {
    "il": "Diyarbakır",
    "ilceler": [
      "Bağlar",
      "Bismil",
      "Dicle",
      "Ergani",
      "Eğil",
      "Hani",
      "Hazro",
      "Kayapınar",
      "Kocaköy",
      "Kulp",
      "Lice",
      "Silvan",
      "Sur",
      "Yenişehir",
      "Çermik",
      "Çüngüş",
      "Çınar"
    ]
  },
  {
    "il": "Düzce",
    "ilceler": [
      "Akçakoca",
      "Cumayeri",
      "Gölyaka",
      "Gümüşova",
      "Kaynaşlı",
      "Merkez",
      "Yığılca",
      "Çilimli"
    ]
  },
  {
    "il": "Edirne",
    "ilceler": [
      "Enez",
      "Havsa",
      "Keşan",
      "Lalapaşa",
      "Meriç",
      "Merkez",
      "Süloğlu",
      "Uzunköprü",
      "İpsala"
    ]
  },
  {
    "il": "Elazığ",
    "ilceler": [
      "Alacakaya",
      "Arıcak",
      "Ağın",
      "Baskil",
      "Karakoçan",
      "Keban",
      "Kovancılar",
      "Maden",
      "Merkez",
      "Palu",
      "Sivrice"
    ]
  },
  {
    "il": "Erzincan",
    "ilceler": [
      "Kemah",
      "Kemaliye",
      "Merkez",
      "Otlukbeli",
      "Refahiye",
      "Tercan",
      "Çayırlı",
      "Üzümlü",
      "İliç"
    ]
  },
  {
    "il": "Erzurum",
    "ilceler": [
      "Aziziye",
      "Aşkale",
      "Horasan",
      "Hınıs",
      "Karayazı",
      "Karaçoban",
      "Köprüköy",
      "Narman",
      "Oltu",
      "Olur",
      "Palandöken",
      "Pasinler",
      "Pazaryolu",
      "Tekman",
      "Tortum",
      "Uzundere",
      "Yakutiye",
      "Çat",
      "İspir",
      "Şenkaya"
    ]
  },
  {
    "il": "Eskişehir",
    "ilceler": [
      "Alpu",
      "Beylikova",
      "Günyüzü",
      "Han",
      "Mahmudiye",
      "Mihalgazi",
      "Mihalıççık",
      "Odunpazarı",
      "Sarıcakaya",
      "Seyitgazi",
      "Sivrihisar",
      "Tepebaşı",
      "Çifteler",
      "İnönü"
    ]
  },
  {
    "il": "Gaziantep",
    "ilceler": [
      "Araban",
      "Karkamış",
      "Nizip",
      "Nurdağı",
      "Oğuzeli",
      "Yavuzeli",
      "İslahiye",
      "Şahinbey",
      "Şehitkamil"
    ]
  },
  {
    "il": "Giresun",
    "ilceler": [
      "Alucra",
      "Bulancak",
      "Dereli",
      "Doğankent",
      "Espiye",
      "Eynesil",
      "Görele",
      "Güce",
      "Keşap",
      "Merkez",
      "Piraziz",
      "Tirebolu",
      "Yağlıdere",
      "Çamoluk",
      "Çanakçı",
      "Şebinkarahisar"
    ]
  },
  {
    "il": "Gümüşhane",
    "ilceler": [
      "Kelkit",
      "Köse",
      "Kürtün",
      "Merkez",
      "Torul",
      "Şiran"
    ]
  },
  {
    "il": "Hakkari",
    "ilceler": [
      "Derecik",
      "Merkez",
      "Yüksekova",
      "Çukurca",
      "Şemdinli"
    ]
  },
  {
    "il": "Hatay",
    "ilceler": [
      "Altınözü",
      "Antakya",
      "Arsuz",
      "Belen",
      "Defne",
      "Dörtyol",
      "Erzin",
      "Hassa",
      "Kumlu",
      "Kırıkhan",
      "Payas",
      "Reyhanlı",
      "Samandağ",
      "Yayladağı",
      "İskenderun"
    ]
  },
  {
    "il": "Isparta",
    "ilceler": [
      "Aksu",
      "Atabey",
      "Eğirdir",
      "Gelendost",
      "Gönen",
      "Keçiborlu",
      "Merkez",
      "Senirkent",
      "Sütçüler",
      "Uluborlu",
      "Yalvaç",
      "Yenişarbademli",
      "Şarkikaraağaç"
    ]
  },
  {
    "il": "Iğdır",
    "ilceler": [
      "Aralık",
      "Karakoyunlu",
      "Merkez",
      "Tuzluca"
    ]
  },
  {
    "il": "Kahramanmaraş",
    "ilceler": [
      "Afşin",
      "Andırın",
      "Dulkadiroğlu",
      "Ekinözü",
      "Elbistan",
      "Göksun",
      "Nurhak",
      "Onikişubat",
      "Pazarcık",
      "Türkoğlu",
      "Çağlayancerit"
    ]
  },
  {
    "il": "Karabük",
    "ilceler": [
      "Eflani",
      "Eskipazar",
      "Merkez",
      "Ovacık",
      "Safranbolu",
      "Yenice"
    ]
  },
  {
    "il": "Karaman",
    "ilceler": [
      "Ayrancı",
      "Başyayla",
      "Ermenek",
      "Kazımkarabekir",
      "Merkez",
      "Sarıveliler"
    ]
  },
  {
    "il": "Kars",
    "ilceler": [
      "Akyaka",
      "Arpaçay",
      "Digor",
      "Kağızman",
      "Merkez",
      "Sarıkamış",
      "Selim",
      "Susuz"
    ]
  },
  {
    "il": "Kastamonu",
    "ilceler": [
      "Abana",
      "Araç",
      "Azdavay",
      "Ağlı",
      "Bozkurt",
      "Cide",
      "Daday",
      "Devrekani",
      "Doğanyurt",
      "Hanönü",
      "Küre",
      "Merkez",
      "Pınarbaşı",
      "Seydiler",
      "Taşköprü",
      "Tosya",
      "Çatalzeytin",
      "İhsangazi",
      "İnebolu",
      "Şenpazar"
    ]
  },
  {
    "il": "Kayseri",
    "ilceler": [
      "Akkışla",
      "Bünyan",
      "Develi",
      "Felahiye",
      "Hacılar",
      "Kocasinan",
      "Melikgazi",
      "Pınarbaşı",
      "Sarıoğlan",
      "Sarız",
      "Talas",
      "Tomarza",
      "Yahyalı",
      "Yeşilhisar",
      "Özvatan",
      "İncesu"
    ]
  },
  {
    "il": "Kilis",
    "ilceler": [
      "Elbeyli",
      "Merkez",
      "Musabeyli",
      "Polateli"
    ]
  },
  {
    "il": "Kocaeli",
    "ilceler": [
      "Başiskele",
      "Darıca",
      "Derince",
      "Dilovası",
      "Gebze",
      "Gölcük",
      "Kandıra",
      "Karamürsel",
      "Kartepe",
      "Körfez",
      "Çayırova",
      "İzmit"
    ]
  },
  {
    "il": "Konya",
    "ilceler": [
      "Ahırlı",
      "Akören",
      "Akşehir",
      "Altınekin",
      "Beyşehir",
      "Bozkır",
      "Cihanbeyli",
      "Derbent",
      "Derebucak",
      "Doğanhisar",
      "Emirgazi",
      "Ereğli",
      "Güneysınır",
      "Hadim",
      "Halkapınar",
      "Hüyük",
      "Ilgın",
      "Kadınhanı",
      "Karapınar",
      "Karatay",
      "Kulu",
      "Meram",
      "Sarayönü",
      "Selçuklu",
      "Seydişehir",
      "Taşkent",
      "Tuzlukçu",
      "Yalıhüyük",
      "Yunak",
      "Çeltik",
      "Çumra"
    ]
  },
  {
    "il": "Kütahya",
    "ilceler": [
      "Altıntaş",
      "Aslanapa",
      "Domaniç",
      "Dumlupınar",
      "Emet",
      "Gediz",
      "Hisarcık",
      "Merkez",
      "Pazarlar",
      "Simav",
      "Tavşanlı",
      "Çavdarhisar",
      "Şaphane"
    ]
  },
  {
    "il": "Kırklareli",
    "ilceler": [
      "Babaeski",
      "Demirköy",
      "Kofçaz",
      "Lüleburgaz",
      "Merkez",
      "Pehlivanköy",
      "Pınarhisar",
      "Vize"
    ]
  },
  {
    "il": "Kırıkkale",
    "ilceler": [
      "Bahşılı",
      "Balışeyh",
      "Delice",
      "Karakeçili",
      "Keskin",
      "Merkez",
      "Sulakyurt",
      "Yahşihan",
      "Çelebi"
    ]
  },
  {
    "il": "Kırşehir",
    "ilceler": [
      "Akpınar",
      "Akçakent",
      "Boztepe",
      "Kaman",
      "Merkez",
      "Mucur",
      "Çiçekdağı"
    ]
  },
  {
    "il": "Malatya",
    "ilceler": [
      "Akçadağ",
      "Arapgir",
      "Arguvan",
      "Battalgazi",
      "Darende",
      "Doğanyol",
      "Doğanşehir",
      "Hekimhan",
      "Kale",
      "Kuluncak",
      "Pütürge",
      "Yazıhan",
      "Yeşilyurt"
    ]
  },
  {
    "il": "Manisa",
    "ilceler": [
      "Ahmetli",
      "Akhisar",
      "Alaşehir",
      "Demirci",
      "Gölmarmara",
      "Gördes",
      "Kula",
      "Köprübaşı",
      "Kırkağaç",
      "Salihli",
      "Saruhanlı",
      "Sarıgöl",
      "Selendi",
      "Soma",
      "Turgutlu",
      "Yunusemre",
      "Şehzadeler"
    ]
  },
  {
    "il": "Mardin",
    "ilceler": [
      "Artuklu",
      "Dargeçit",
      "Derik",
      "Kızıltepe",
      "Mazıdağı",
      "Midyat",
      "Nusaybin",
      "Savur",
      "Yeşilli",
      "Ömerli"
    ]
  },
  {
    "il": "Mersin",
    "ilceler": [
      "Akdeniz",
      "Anamur",
      "Aydıncık",
      "Bozyazı",
      "Erdemli",
      "Gülnar",
      "Mezitli",
      "Mut",
      "Silifke",
      "Tarsus",
      "Toroslar",
      "Yenişehir",
      "Çamlıyayla"
    ]
  },
  {
    "il": "Muğla",
    "ilceler": [
      "Bodrum",
      "Dalaman",
      "Datça",
      "Fethiye",
      "Kavaklıdere",
      "Köyceğiz",
      "Marmaris",
      "Menteşe",
      "Milas",
      "Ortaca",
      "Seydikemer",
      "Ula",
      "Yatağan"
    ]
  },
  {
    "il": "Muş",
    "ilceler": [
      "Bulanık",
      "Hasköy",
      "Korkut",
      "Malazgirt",
      "Merkez",
      "Varto"
    ]
  },
  {
    "il": "Nevşehir",
    "ilceler": [
      "Acıgöl",
      "Avanos",
      "Derinkuyu",
      "Gülşehir",
      "Hacıbektaş",
      "Kozaklı",
      "Merkez",
      "Ürgüp"
    ]
  },
  {
    "il": "Niğde",
    "ilceler": [
      "Altunhisar",
      "Bor",
      "Merkez",
      "Ulukışla",
      "Çamardı",
      "Çiftlik"
    ]
  },
  {
    "il": "Ordu",
    "ilceler": [
      "Akkuş",
      "Altınordu",
      "Aybastı",
      "Fatsa",
      "Gölköy",
      "Gülyalı",
      "Gürgentepe",
      "Kabadüz",
      "Kabataş",
      "Korgan",
      "Kumru",
      "Mesudiye",
      "Perşembe",
      "Ulubey",
      "Çamaş",
      "Çatalpınar",
      "Çaybaşı",
      "Ünye",
      "İkizce"
    ]
  },
  {
    "il": "Osmaniye",
    "ilceler": [
      "Bahçe",
      "Düziçi",
      "Hasanbeyli",
      "Kadirli",
      "Merkez",
      "Sumbas",
      "Toprakkale"
    ]
  },
  {
    "il": "Rize",
    "ilceler": [
      "Ardeşen",
      "Derepazarı",
      "Fındıklı",
      "Güneysu",
      "Hemşin",
      "Kalkandere",
      "Merkez",
      "Pazar",
      "Çamlıhemşin",
      "Çayeli",
      "İkizdere",
      "İyidere"
    ]
  },
  {
    "il": "Sakarya",
    "ilceler": [
      "Adapazarı",
      "Akyazı",
      "Arifiye",
      "Erenler",
      "Ferizli",
      "Geyve",
      "Hendek",
      "Karapürçek",
      "Karasu",
      "Kaynarca",
      "Kocaali",
      "Pamukova",
      "Sapanca",
      "Serdivan",
      "Söğütlü",
      "Taraklı"
    ]
  },
  {
    "il": "Samsun",
    "ilceler": [
      "19 Mayıs",
      "Alaçam",
      "Asarcık",
      "Atakum",
      "Ayvacık",
      "Bafra",
      "Canik",
      "Havza",
      "Kavak",
      "Ladik",
      "Salıpazarı",
      "Tekkeköy",
      "Terme",
      "Vezirköprü",
      "Yakakent",
      "Çarşamba",
      "İlkadım"
    ]
  },
  {
    "il": "Siirt",
    "ilceler": [
      "Baykan",
      "Eruh",
      "Kurtalan",
      "Merkez",
      "Pervari",
      "Tillo",
      "Şirvan"
    ]
  },
  {
    "il": "Sinop",
    "ilceler": [
      "Ayancık",
      "Boyabat",
      "Dikmen",
      "Durağan",
      "Erfelek",
      "Gerze",
      "Merkez",
      "Saraydüzü",
      "Türkeli"
    ]
  },
  {
    "il": "Sivas",
    "ilceler": [
      "Akıncılar",
      "Altınyayla",
      "Divriği",
      "Doğanşar",
      "Gemerek",
      "Gölova",
      "Gürün",
      "Hafik",
      "Kangal",
      "Koyulhisar",
      "Merkez",
      "Suşehri",
      "Ulaş",
      "Yıldızeli",
      "Zara",
      "İmranlı",
      "Şarkışla"
    ]
  },
  {
    "il": "Tekirdağ",
    "ilceler": [
      "Ergene",
      "Hayrabolu",
      "Kapaklı",
      "Malkara",
      "Marmaraereğlisi",
      "Muratlı",
      "Saray",
      "Süleymanpaşa",
      "Çerkezköy",
      "Çorlu",
      "Şarköy"
    ]
  },
  {
    "il": "Tokat",
    "ilceler": [
      "Almus",
      "Artova",
      "Başçiftlik",
      "Erbaa",
      "Merkez",
      "Niksar",
      "Pazar",
      "Reşadiye",
      "Sulusaray",
      "Turhal",
      "Yeşilyurt",
      "Zile"
    ]
  },
  {
    "il": "Trabzon",
    "ilceler": [
      "Akçaabat",
      "Araklı",
      "Arsin",
      "Beşikdüzü",
      "Dernekpazarı",
      "Düzköy",
      "Hayrat",
      "Köprübaşı",
      "Maçka",
      "Of",
      "Ortahisar",
      "Sürmene",
      "Tonya",
      "Vakfıkebir",
      "Yomra",
      "Çarşıbaşı",
      "Çaykara",
      "Şalpazarı"
    ]
  },
  {
    "il": "Tunceli",
    "ilceler": [
      "Hozat",
      "Mazgirt",
      "Merkez",
      "Nazımiye",
      "Ovacık",
      "Pertek",
      "Pülümür",
      "Çemişgezek"
    ]
  },
  {
    "il": "Uşak",
    "ilceler": [
      "Banaz",
      "Eşme",
      "Karahallı",
      "Merkez",
      "Sivaslı",
      "Ulubey"
    ]
  },
  {
    "il": "Van",
    "ilceler": [
      "Bahçesaray",
      "Başkale",
      "Edremit",
      "Erciş",
      "Gevaş",
      "Gürpınar",
      "Muradiye",
      "Saray",
      "Tuşba",
      "Çaldıran",
      "Çatak",
      "Özalp",
      "İpekyolu"
    ]
  },
  {
    "il": "Yalova",
    "ilceler": [
      "Altınova",
      "Armutlu",
      "Merkez",
      "Termal",
      "Çiftlikköy",
      "Çınarcık"
    ]
  },
  {
    "il": "Yozgat",
    "ilceler": [
      "Akdağmadeni",
      "Aydıncık",
      "Boğazlıyan",
      "Kadışehri",
      "Merkez",
      "Saraykent",
      "Sarıkaya",
      "Sorgun",
      "Yenifakılı",
      "Yerköy",
      "Çandır",
      "Çayıralan",
      "Çekerek",
      "Şefaatli"
    ]
  },
  {
    "il": "Zonguldak",
    "ilceler": [
      "Alaplı",
      "Devrek",
      "Ereğli",
      "Gökçebey",
      "Kilimli",
      "Kozlu",
      "Merkez",
      "Çaycuma"
    ]
  },
  {
    "il": "Çanakkale",
    "ilceler": [
      "Ayvacık",
      "Bayramiç",
      "Biga",
      "Bozcaada",
      "Eceabat",
      "Ezine",
      "Gelibolu",
      "Gökçeada",
      "Lapseki",
      "Merkez",
      "Yenice",
      "Çan"
    ]
  },
  {
    "il": "Çankırı",
    "ilceler": [
      "Atkaracalar",
      "Bayramören",
      "Eldivan",
      "Ilgaz",
      "Korgun",
      "Kurşunlu",
      "Kızılırmak",
      "Merkez",
      "Orta",
      "Yapraklı",
      "Çerkeş",
      "Şabanözü"
    ]
  },
  {
    "il": "Çorum",
    "ilceler": [
      "Alaca",
      "Bayat",
      "Boğazkale",
      "Dodurga",
      "Kargı",
      "Laçin",
      "Mecitözü",
      "Merkez",
      "Ortaköy",
      "Osmancık",
      "Oğuzlar",
      "Sungurlu",
      "Uğurludağ",
      "İskilip"
    ]
  },
  {
    "il": "İstanbul",
    "ilceler": [
      "Adalar",
      "Arnavutköy",
      "Ataşehir",
      "Avcılar",
      "Bahçelievler",
      "Bakırköy",
      "Bayrampaşa",
      "Bağcılar",
      "Başakşehir",
      "Beykoz",
      "Beylikdüzü",
      "Beyoğlu",
      "Beşiktaş",
      "Büyükçekmece",
      "Esenler",
      "Esenyurt",
      "Eyüpsultan",
      "Fatih",
      "Gaziosmanpaşa",
      "Güngören",
      "Kadıköy",
      "Kartal",
      "Kağıthane",
      "Küçükçekmece",
      "Maltepe",
      "Pendik",
      "Sancaktepe",
      "Sarıyer",
      "Silivri",
      "Sultanbeyli",
      "Sultangazi",
      "Tuzla",
      "Zeytinburnu",
      "Çatalca",
      "Çekmeköy",
      "Ümraniye",
      "Üsküdar",
      "Şile",
      "Şişli"
    ]
  },
  {
    "il": "İzmir",
    "ilceler": [
      "Aliağa",
      "Balçova",
      "Bayraklı",
      "Bayındır",
      "Bergama",
      "Beydağ",
      "Bornova",
      "Buca",
      "Dikili",
      "Foça",
      "Gaziemir",
      "Güzelbahçe",
      "Karabağlar",
      "Karaburun",
      "Karşıyaka",
      "Kemalpaşa",
      "Kiraz",
      "Konak",
      "Kınık",
      "Menderes",
      "Menemen",
      "Narlıdere",
      "Seferihisar",
      "Selçuk",
      "Tire",
      "Torbalı",
      "Urla",
      "Çeşme",
      "Çiğli",
      "Ödemiş"
    ]
  },
  {
    "il": "Şanlıurfa",
    "ilceler": [
      "Akçakale",
      "Birecik",
      "Bozova",
      "Ceylanpınar",
      "Eyyübiye",
      "Halfeti",
      "Haliliye",
      "Harran",
      "Hilvan",
      "Karaköprü",
      "Siverek",
      "Suruç",
      "Viranşehir"
    ]
  },
  {
    "il": "Şırnak",
    "ilceler": [
      "Beytüşşebap",
      "Cizre",
      "Güçlükonak",
      "Merkez",
      "Silopi",
      "Uludere",
      "İdil"
    ]
  }
];
